<script setup lang="ts">
withDefaults(
    defineProps<{
        title?: string;
        src?: string;
    }>(),
    {
        title: '',
        src: '',
    },
);
</script>

<template>
    <picture class="ui-picture">
        <source :srcset="src" />
        <img
            :src="src"
            :title="title"
            :alt="title"
            v-bind="$attrs"
            class="ui-picture__img"
        />
    </picture>
</template>

<style scoped lang="scss">
@import 'styles/ui-picture';
</style>
